import Swiper from "swiper";

import { Navigation, FreeMode, Autoplay } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
  // Select all [ data-component="single-carousel"] blocks
  const blocks = document.querySelectorAll(
    "[data-component='single-carousel']"
  );

  blocks.forEach((block) => {
    const slider = block.querySelector(".swiper");

    if (!slider) return;

    const trail = slider.querySelector(".swiper-wrapper");
    const nav = block.querySelector(".swiper-navigation");
    const prev = nav ? nav.querySelector(".swiper-button-prev") : null;
    const next = nav ? nav.querySelector(".swiper-button-next") : null;

    const hasProp = (prop, obj) =>
      Object.keys(obj).filter((key) => key === prop).length > 0;

    // Create a variable for data-autoplay on .swiper, if it exists true, false otherwise
    const hasAutoplay =
      hasProp("autoplay", slider.dataset) &&
      slider.dataset.autoplay !== "false";
    const overflowHidden = slider.classList.contains("hide-trail");

    const slides = trail.querySelectorAll(".swiper-slide");

    if (!trail || !slides.length) {
      console.warn("El contenedor Swiper no se encontró en:", block);
      return;
    }

    const swiperConfig = {
      slidesPerView: 1.5,
      spaceBetween: 0,
      centeredSlides: false,
      loop: false,
      speed: 800,
      allowTouchMove: true,
      rewind: true,
      ...(hasAutoplay && {
        autoplay: {
          delay: 1500,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        },
      }),

      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      breakpoints: {
        1020: {
          slidesPerView: slides.length > 3 ? 3.5 : slides.length - 1 + 0.5,
          allowTouchMove: true,
          freeMode: {
            enabled: true,
            sticky: true,
            minimumVelocity: 0.1,
            freeModeMomentum: true,
          },
        },
      },
      modules: [Navigation, FreeMode, Autoplay],
    };

    const swiper = new Swiper(slider, swiperConfig);
  });
});
